import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import WithAuth from "../../hoc/WithAuth";
import { useGetMFIDashboardValues } from "../../api/agronomy";
import StatCard from "../../components/cards/stat-card/StatCard";
import ContractsTable from "../../components/tables/ContractsTable";
import { useNavigate } from "react-router-dom";
import { Pie, Bar, Line, Doughnut } from "react-chartjs-2";
import { useContractList } from "../../api/contract";
import ContractDashboard from "../../components/ContractDashboard";
import LoadingScreen from "../../components/LoadingScreen";
import { useGetStatusCount } from "../../hooks/useGetStatusCount";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
);

const AmfiDashboard = () => {
  const [tableIndex, setTableIndex] = useState<number>(0);
  const { data: bankDashboardValues } = useGetMFIDashboardValues();
  const [searchText, setSearchText] = useState("");
  const { data: contracts, isLoading } = useContractList();
  const [filteredContracts, setFilteredContracts] = useState<any[]>([]);
  const [statuses, setStatuses] = useState<any>({
    Signed: 0,
    Unsigned: 0,
  });
  const [selectedFilterIndex, setSelectedFilterIndex] = useState(0);
  const filters = useGetStatusCount(statuses);

  const navigate = useNavigate();

  useEffect(() => {
    if (contracts && contracts.data && contracts.data.data) {
      const modifiedData = contracts.data.data.map((item: any) => ({
        ...item,
      }));

      const signed = modifiedData.filter(
        (item: any) => item.contractStatus === "SIGNED",
      ).length;
      const unsigned = modifiedData.length - signed;

      setStatuses({ Signed: signed, Unsigned: unsigned });

      let filteredData = modifiedData;

      if (selectedFilterIndex === 1) {
        filteredData = filteredData.filter(
          (item: any) => item.contractStatus === "SIGNED",
        );
      } else if (selectedFilterIndex === 2) {
        filteredData = filteredData.filter(
          (item: any) => item.contractStatus !== "SIGNED",
        );
      }

      if (searchText) {
        filteredData = filteredData.filter(
          (item: any) =>
            item.contractNumber
              ?.toLowerCase()
              .includes(searchText.toLowerCase()) ||
            item.offTaker?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.fullName?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.product?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.contractStatus
              ?.toLowerCase()
              .includes(searchText.toLowerCase()),
        );
      }

      setFilteredContracts(filteredData);
    }
  }, [searchText, contracts, selectedFilterIndex]);

  if (isLoading) return <LoadingScreen />;
  return (
    <div className="w-full">
      <div className="w-full flex flex-col gap-6">
        <div
          style={{
            justifyContent: "space-between",
            borderRadius: 8.5,
            marginTop: 25,
            paddingLeft: 50,
            paddingRight: 50,
            paddingTop: 22,
            backgroundColor: "white",
          }}
        >
          <ContractDashboard contractData={filteredContracts} />

          {/* <ContractsTable
        searchText={searchText}
        setSearchText={setSearchText}
        filteredContracts={filteredContracts}
        isLoading={isLoading}
        selectedFilterIndex={selectedFilterIndex}
        setSelectedFilterIndex={setSelectedFilterIndex}
        filters={filters}
      /> */}
        </div>
      </div>
    </div>
  );
};

export default WithAuth(AmfiDashboard);
